
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";

export const useWorksheetDelete = () => {
  const { toast } = useToast();

  const deleteWorksheet = async (id: number): Promise<boolean> => {
    try {
      const { error } = await supabase
        .from("worksheets")
        .delete()
        .eq("id", id);
        
      if (error) throw error;
      
      toast({
        title: "ลบชีทสำเร็จ",
        description: "ลบชีทเรียบร้อยแล้ว",
      });
      
      return true;
    } catch (error: any) {
      console.error("Error deleting worksheet:", error.message);
      toast({
        title: "เกิดข้อผิดพลาด",
        description: `ไม่สามารถลบชีทได้: ${error.message}`,
        variant: "destructive"
      });
      return false;
    }
  };

  return { deleteWorksheet };
};
